import { GNB_DROPDOWN_CONFIGS, NAV_ITEMS } from '@repo/common';

const BUSINESS_ROLES = new Set([
  'E',
  'ROLE_E',
  'EMPLOYER',
  'ROLE_EMPLOYER',
  'EMPLOYEE',
  'ROLE_EMPLOYEE',
]);
const ADMIN_ROLES = new Set(['A', 'ROLE_A', 'ADMIN', 'ROLE_ADMIN']);

export const isBusinessRole = (role) =>
  BUSINESS_ROLES.has(String(role || '').toUpperCase());

const HIRING_ITEMS = [
  { label: 'Job Postings', href: '/jobs/admin', requireAuth: true },
  // 마이페이지 Jobs 메뉴 (비즈니스 계정은 이 탭에서 지원자를 관리한다)
  { label: 'Applicants', href: '/mypage?tab=My Apply', requireAuth: true },
];

const BUSINESS_NAV_ITEMS = NAV_ITEMS.flatMap((item) =>
  item.label === 'Job Board'
    ? [item, { label: 'Hiring', href: '/jobs/admin' }]
    : [item],
);

const HIRING_DROPDOWN_CONFIG = {
  sections: [{ items: HIRING_ITEMS }],
  card: null,
  cards: [],
  hideCards: true,
};

export const getNavItems = (role) =>
  isBusinessRole(role) ? BUSINESS_NAV_ITEMS : NAV_ITEMS;

export const getGnbDropdownConfig = (label, role) => {
  const normalizedRole = String(role || '').toUpperCase();

  if (isBusinessRole(normalizedRole)) {
    if (label === 'Hiring') return HIRING_DROPDOWN_CONFIG;
    // 채용 관련 하위 메뉴는 Hiring 으로 옮겼으므로 Job Board 는 단일 링크로 둔다
    if (label === 'Job Board') return null;
    return GNB_DROPDOWN_CONFIGS[label];
  }

  const config = GNB_DROPDOWN_CONFIGS[label];
  if (!config) return config;

  if (label !== 'Job Board' || !ADMIN_ROLES.has(normalizedRole)) return config;

  return {
    ...config,
    sections: config.sections.map((section, index) =>
      index === 0
        ? {
            ...section,
            items: [
              ...section.items,
              { label: 'Manage Jobs', href: '/jobs/admin', requireAuth: true },
            ],
          }
        : section,
    ),
  };
};

/** 드롭다운 하위 메뉴 전체 (현재 경로가 어느 GNB 메뉴에 속하는지 판별용) */
export const getDropdownItems = (label, role) =>
  (getGnbDropdownConfig(label, role)?.sections ?? []).flatMap(
    (section) => section.items,
  );
